import React, { useEffect, useState } from "react";
import { search_icon, view_icon } from "../../../assets/imgs";
import StatusComp from "../../../components/StatusComp";
import CommonDatePicker from "../../../components/CommonDatePicker";
import SelectBox from "../../../components/SelectBox";
import { Table } from "../../../components/Table/Table";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { recentAlerts } from "../../redux/api/dummyJson";
import { get, post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";

const AllocatedAlerts = () => {
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const severity = [
    { id: 1, name: "severity 1" },
    { id: 2, name: "severity 2" },
    { id: 3, name: "severity 3" },
  ];

  const classifiedList = [
    { id: 1, name: "All" },
    { id: 2, name: "Assigned" },
  ];

  const typeArr = [
    { id: 1, name: "No_Harness" },
    { id: 2, name: "No_Helmet" },
    { id: 3, name: "No_Shoes" },
    { id: 4, name: "Vehicle collision with human" },
    { id: 5, name: "Danger under lifted load" },
  ];

  const [camera, setCamera] = useState([]);
  const [type, setType] = useState([]);
  const cameraArr = [
    { id: 1, name: "TMZSt62 PM Cam 01" },
    { id: 2, name: "TMZSt62 PM Cam 02" },
    { id: 3, name: "TMZSt62 PM Cam 03" },
    { id: 4, name: "TMZSt62 PM Cam 04" },
    { id: 5, name: "TMZSt62 PM Cam 05" },
  ];

  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");
  const [sites, setSites] = useState(null);
  const [list, setList] = useState([]);
  const [selectSite, setSelectSite] = useState({});
  const [siteList, setSiteList] = useState([]);

  const [typeDrop, setTypeDrop] = useState(null);
  const [cam, setCam] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [classified, setClassified] = useState(null);
  const givenuser = JSON.parse(localStorage.getItem("user_details"));

  console.log("selecetedOptions", sites);

  const handleFilter = () => {};

  const capturedAt = moment().format("DD-MM-YYYY, h:mm A");
  const allocatedAt = moment().add(1, "days").format("DD-MM-YYYY, h:mm A");

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "sno",
        Cell: ({ value, row }) => {
          let reassigns =
            row.original.reassigns?.[row.original.reassigns?.length - 1];
          return (
            <p
              className={`${
                row.original.status == 6
                  ? "text-dark"
                  : reassigns?.reassigned_id
                    ? "text-success"
                    : "text-danger"
              }`}
            >
              {(page - 1) * 10 + row.index + 1}
            </p>
          );
        },
      },
      {
        Header: "Alert ID",
        accessor: "",
        Cell: ({ value, row }) => {
          let reassigns =
            row.original.reassigns?.[row.original.reassigns?.length - 1];
          return (
            <p
              className={`${
                row.original.status == 6
                  ? "text-dark"
                  : reassigns?.reassigned_id
                    ? "text-success"
                    : "text-danger"
              }`}
            >{`${row.original.id}`}</p>
          );
        },
      },
      {
        Header: "Alert Type",
        accessor: "alert_type",
        Cell: ({ value, row }) => {
          let reassigns =
            row.original.reassigns?.[row.original.reassigns?.length - 1];
          return (
            <p
              className={`${
                row.original.status == 6
                  ? "text-dark"
                  : reassigns?.reassigned_id
                    ? "text-success"
                    : "text-danger"
              }`}
            >
              {value}
            </p>
          );
        },
      },
      {
        Header: "Classified",
        accessor: "classified",
        Cell: ({ value, row }) => {
          let reassigns =
            row.original.reassigns?.[row.original.reassigns?.length - 1];
          return (
            <p
              className={`${
                row.original.status == 6
                  ? "text-dark"
                  : reassigns?.reassigned_id
                    ? "text-success"
                    : "text-danger"
              }`}
            >
              {value == 1
                ? "New"
                : value == 2
                  ? "Invalid"
                  : value == 3
                    ? "Compliant"
                    : value == 4
                      ? "Non - Compliant"
                      : ""}
            </p>
          );
        },
      },
      {
        Header: "Camera Number",
        accessor: "camera_code",
        Cell: ({ value, row }) => {
          let reassigns =
            row.original.reassigns?.[row.original.reassigns?.length - 1];
          return (
            <p
              className={`${
                row.original.status == 6
                  ? "text-dark"
                  : reassigns?.reassigned_id
                    ? "text-success"
                    : "text-danger"
              }`}
            >
              {value}
            </p>
          );
        },
      },
      {
        Header: "Camera Name",
        accessor: "camera_name",
        Cell: ({ value, row }) => {
          let reassigns =
            row.original.reassigns?.[row.original.reassigns?.length - 1];
          return (
            <p
              className={`${
                row.original.status == 6
                  ? "text-dark"
                  : reassigns?.reassigned_id
                    ? "text-success"
                    : "text-danger"
              }`}
            >
              {value}
            </p>
          );
        },
      },

      {
        Header: "Captured At",
        accessor: "captured_at",
        Cell: ({ value, row }) => {
          let reassigns =
            row.original.reassigns?.[row.original.reassigns?.length - 1];
          return (
            <p
              className={`${
                row.original.status == 6
                  ? "text-dark"
                  : reassigns?.reassigned_id
                    ? "text-success"
                    : "text-danger"
              }`}
            >
              {value ? moment(value).format("DD-MM-YYYY, hh:mm A") : "-"}
            </p>
          );
        },
      },
      {
        Header: "Allocated At",
        accessor: "allocated_at",
        Cell: ({ value, row }) => {
          let reassigns =
            row.original.reassigns?.[row.original.reassigns?.length - 1];
          return (
            <p
              className={`${
                row.original.status == 6
                  ? "text-dark"
                  : reassigns?.reassigned_id
                    ? "text-success"
                    : "text-danger"
              }`}
            >
              {/* {value ? moment(value).format("DD-MM-YYYY hh:mm A") : "-"} */}
              {value}
            </p>
          );
        },
      },
      {
        Header: "Resource Name",
        accessor: "",
        Cell: ({ value, row }) => {
          let reassigns =
            row.original.reassigns?.[row.original.reassigns?.length - 1];
          let resource_name = "-";
          if (
            row.original.reassigns?.length > 0 &&
            row.original.reassigns?.[row.original.reassigns?.length - 1]
              ?.reassigned_to
          ) {
            resource_name =
              row.original.reassigns?.[row.original.reassigns?.length - 1]
                ?.reassigned_to;
          } else if (row.original.assigned?.assigned_to) {
            resource_name = row.original.assigned?.assigned_to;
          }
          return (
            <p
              className={`${
                row.original.status == 6
                  ? "text-dark"
                  : reassigns?.reassigned_id
                    ? "text-success"
                    : "text-danger"
              }`}
            >
              {resource_name}
            </p>
          );
        },
      },
      {
        Header: "Severity",
        accessor: "severity",
        Cell: ({ value, row }) => {
          let reassigns =
            row.original.reassigns?.[row.original.reassigns?.length - 1];
          return (
            <p
              className={`${
                row.original.status == 6
                  ? "text-dark"
                  : reassigns?.reassigned_id
                    ? "text-success"
                    : "text-danger"
              }`}
            >
              {value}
            </p>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc gap-3">
                <button
                  onClick={() =>
                    navigate("/group-assign-alertdetails", {
                      state: {
                        data: row?.original,
                        type: "allocated",
                      },
                    })
                  }
                  className="cust-btn "
                >
                  <img src={view_icon} alt="" className=" edit-btn " />
                </button>
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [page],
  );

  const getCameraList = (site_id) => {
    let formdata = new FormData();
    formdata.append("site_id", site_id);
    // formdata.append("site_id", 2);
    post(URL.CAMERA_LISTS, formdata)
      .then((res) => {
        if (res?.cameras?.length > 0) {
          let temp = [];
          res?.cameras?.map((item, ind) => {
            let obj_ = {
              ...item,
              name_old: item?.name,
              name: `${item?.code} - ${item?.name}`,
            };
            temp.push(obj_);
          });
          setCamera(temp);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getAlertTypes = (site_id) => {
    get(URL.GROUP_USERS + site_id)
      .then((res) => {
        console.log("res", res);

        if (res?.data?.alert_types?.length > 0) {
          let temp = [];
          res?.data?.alert_types?.map((item, ind) => {
            let obi = {
              ...item,
            };
            obi.id = item?.alert_type_id;
            obi.name = item?.alert_name;
            temp.push(obi);
          });
          console.log("temp", temp);

          setType(temp);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getNotification = (
    from_date,
    to_date,
    search_value,
    type_value,
    camera_id,
    severity_type,
    page_no,
  ) => {
    let formdata = new FormData();
    formdata.append("page", page_no);
    formdata.append("type", 3);
    if (user_details?.knf_type >= 4 && user_details?.knf_type <= 5) {
      formdata.append("site_id", selectSite?.value);
    } else {
      formdata.append("user_id", givenuser?.id);
    }
    if (camera_id?.value) {
      formdata.append("camera_id", camera_id?.value);
    }
    if (from_date) {
      formdata.append("from_date", moment(from_date).format("DD-MM-YYYY"));
    }
    if (to_date) {
      formdata.append("to_date", moment(to_date).format("DD-MM-YYYY"));
    }
    if (type_value?.value) {
      formdata.append("alert_id", type_value?.value);
    }

    if (severity_type?.value) {
      formdata.append("severity", severity_type?.value);
    }

    if (search_value) {
      formdata.append("search", search_value);
    }

    setSearchText(search_value);
    setFromDate(from_date);
    setToDate(to_date);
    setCam(camera_id);
    setTypeDrop(type_value);
    setSites(severity_type);
    setPage(page_no);
    post(URL.USER_NOTIFICATION, formdata)
      .then((res) => {
        if (res?.status == "success") {
          setList(res?.lists);
          setPagination(res?.pagination_meta);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (loginData?.sites?.length > 0) {
      setSiteList(loginData?.sites);
      setSelectSite({
        label: loginData?.sites?.[0]?.name,
        value: loginData?.sites?.[0]?.id,
      });
    }
  }, []);

  useEffect(() => {
    if (user_details?.knf_type >= 4 && user_details?.knf_type <= 5) {
      if (selectSite?.value) {
        getCameraList(selectSite?.value);
        getAlertTypes(selectSite?.value);
      }
    } else {
      getCameraList(givenuser?.knf_company_site_id);
      getAlertTypes(givenuser?.knf_company_site_id);
    }
  }, [selectSite]);

  useEffect(() => {
    if (user_details?.knf_type >= 4 && user_details?.knf_type <= 5) {
      if (selectSite?.value) {
        getNotification(
          fromDate,
          toDate,
          searchText,
          typeDrop,
          cam,
          sites,
          page,
        );
      }
    } else {
      getNotification(fromDate, toDate, searchText, typeDrop, cam, sites, page);
    }
  }, [page, selectSite]);

  const getFromDate = (date) => {
    getNotification(date, toDate, searchText, typeDrop, cam, sites, page);
  };

  const getToDate = (date) => {
    getNotification(fromDate, date, searchText, typeDrop, cam, sites, page);
  };

  return (
    <div className="dashRightView">
      <StatusComp name={"Assigned Alerts"} hide={true} />

      {user_details?.knf_type >= 4 && user_details?.knf_type <= 5 && (
        <div className="col-md-2 mb-3">
          <label className="form-label">Select Site</label>
          <SelectBox
            arrayData={siteList}
            selectedOption={selectSite}
            setSelectedOption={setSelectSite}
            style={true}
          />
        </div>
      )}

      <div className="d-flex ac-js gap-5 m-2">
        <CommonDatePicker
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />

        <div className="search-input" style={{ marginTop: "32px" }}>
          <input
            onChange={(e) => {
              setSearchText(e.target.value);
              // getNotification(
              //   fromDate,
              //   toDate,
              //   e.target.value,
              //   typeDrop,
              //   cam,
              //   sites,
              //   page
              // );
            }}
            value={searchText}
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
          />
          <img src={search_icon} className="search" />
        </div>

        <div className="d-flex flex-row justify-content-end col-md-3 gap-2">
          <button
            className="submit-btn mt-4"
            style={{ width: "100px" }}
            onClick={() =>
              getNotification(
                fromDate,
                toDate,
                searchText,
                typeDrop,
                cam,
                sites,
                1,
              )
            }
            // onClick={() => getNotification("", "", "", "", "", "", 1)}
          >
            Filter
          </button>
          <button
            className="submit-btn mt-4"
            style={{ width: "100px" }}
            onClick={() => getNotification("", "", "", "", "", "", 1)}
          >
            Refresh
          </button>
        </div>
      </div>

      <div className="d-flex gap-5 m-2 mt-4">
        <div className="col-md-2 ">
          <label className="form-label">Select Type</label>
          <SelectBox
            arrayData={type}
            selectedOption={typeDrop}
            setSelectedOption={setTypeDrop}
            style={true}
          />
        </div>
        {/* <div className="col-md-2 ">
          <label className="form-label">Classified</label>
          <SelectBox
            arrayData={classifiedList}
            selectedOption={classified}
            setSelectedOption={setClassified}
            style={true}
          />
        </div> */}
        <div className="col-md-2 ">
          <label className="form-label">Select Camera</label>
          <SelectBox
            arrayData={camera}
            selectedOption={cam}
            setSelectedOption={setCam}
            style={true}
          />
        </div>

        <div className="col-md-2 ">
          <label className="form-label">Select severity</label>
          <SelectBox
            arrayData={severity}
            selectedOption={sites}
            setSelectedOption={setSites}
            style={true}
          />
        </div>
      </div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list}
        show={true}
      />
    </div>
  );
};

export default AllocatedAlerts;
